import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Typography } from '@telus-uds/components-web';

import { storeCodes } from '../../../../utils/constant';

import ErrorIcon from '../../../../../assets/images/icon_error_messages.gif';

const CorpStoreField = ({ values, label, touched, errors, setFieldValue }) => {

    return (
        <>
            <div className="main-content-form-headers">
                <Typography block heading="h4" variant={{ size: 'h4' }}>{label}</Typography>
            </div>
            <div
                style={{ position: 'relative' }}
                className={`input-container ${errors.storeCode && touched.storeCode ? 'error' : ''
                    }`}
            >
                <Typeahead
                    id="single-typeahead"
                    placeholder={label}
                    selected={values.storeCode ? [values.storeCode] : []} // Use selected
                    onChange={(selected) => {
                        const selectedCode = selected[0] || '';
                        setFieldValue(selectedCode);
                    }}
                    options={storeCodes}
                />

                <>
                    <div className="error_messages">
                        <Typography variant={{ colour: 'error' }}>{errors.storeCode}</Typography>
                    </div>
                    <div id="username_error_icon" className="error_messages_icon">
                        <img src={ErrorIcon} alt="error_icon" />
                    </div>
                </>
            </div>
        </>
    );
};

CorpStoreField.propTypes = {
    values: PropTypes.objectOf(PropTypes.string).isRequired,
    label: PropTypes.objectOf(PropTypes.string).isRequired,
    touched: PropTypes.objectOf(PropTypes.bool).isRequired,
    errors: PropTypes.objectOf(PropTypes.string).isRequired,
    setFieldValue : PropTypes.func.isRequired

};

export default CorpStoreField;
